var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0127C24.8366 32.0127 32 24.8493 32 16.0127C32 7.17614 24.8366 0.0126953 16 0.0126953C7.16344 0.0126953 0 7.17614 0 16.0127C0 24.8493 7.16344 32.0127 16 32.0127Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0128C0 22.0774 3.37431 27.3536 8.34781 30.0673V1.95819C3.37431 4.67188 0 9.94807 0 16.0128Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 0.0126953C13.2287 0.0126953 10.6216 0.717883 8.34839 1.95813V30.0672C10.6216 31.3075 13.2287 32.0127 16.0006 32.0127C24.8371 32.0127 32.0006 24.8492 32.0006 16.0127C32.0006 7.1762 24.8371 0.0126953 16.0006 0.0126953Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8415 18.6586C20.8173 20.1212 17.9907 19.666 16.5282 17.6418C15.0656 15.6176 15.5209 12.791 17.5451 11.3285C18.1762 10.8725 18.8853 10.603 19.6068 10.5093C18.2188 10.3017 16.7516 10.6145 15.5243 11.5013C13.0331 13.3014 12.4726 16.7802 14.2727 19.2716C16.0728 21.7628 19.5516 22.3233 22.043 20.523C23.2704 19.6362 24.028 18.3416 24.2666 16.9586C23.9513 17.614 23.4727 18.2026 22.8415 18.6586V18.6586Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7553 10.4476L23.8955 11.6764L25.4165 10.9719L24.6001 12.4359L25.7403 13.6649L24.0955 13.3408L23.2791 14.8049L23.0791 13.1406L21.4343 12.8165L22.9554 12.112L22.7553 10.4476Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakistan);
export default __webpack_public_path__ + "static/media/pakistan.e2c04753.svg";
export { ForwardRef as ReactComponent };